import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from "@angular/forms";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {PopoverModule} from "ngx-bootstrap/popover";
import {DateRangePickerPopoverComponent} from "./date-range-picker-popover.component";
import {DeptCategoryPickerModule} from '../dept-category-picker/dept-category-picker.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonModule } from '@xref/xref-lib';


@NgModule({
  declarations: [DateRangePickerPopoverComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    DeptCategoryPickerModule,
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    BsDropdownModule.forRoot(),
    ButtonModule
  ],
  exports: [DateRangePickerPopoverComponent]
})
export class DateRangePickerPopoverModule {
}
